import React, { useState } from "react";
import AccDashboard from "../Accountant/AccDashboard";
import HrDashboard from "../HR/HrDashboard";
import CompanyInfo from "../../Setting/Owner/CompanyInfo/CompanyInfo";
import InventoryDashboard from "../../Inventory/Dashboard/InventoryDashboard";
import useCompanyStore from "../../../store/useCompanyStore";

function OwnerDashboard() {
  const [activePage, setActivePage] = useState("ACC Dashboard");
  const { companyInfo } = useCompanyStore();

  const pages = ["ACC Dashboard", "HR Dashboard", "Inventory Dashboard", "Company Information"];
  return (
    <div className="flex flex-col gap-4">
      {companyInfo ? (
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 rounded-xl shadow-md mb-2">
          <h1 className="text-3xl font-extrabold text-white tracking-tight">
            {companyInfo.name}
          </h1>
          <p className="text-blue-100 text-sm mt-1 opacity-90">Company Overview & Dashboards</p>
        </div>
      ) : (
        <div
          className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4"
          role="alert"
        >
          <p className="font-bold">Company Information Required</p>
          <p>
            Please fill in the Company Information first as it is required to
            generate Books of accounts.
          </p>
        </div>
      )}
      <header className="flex justify-between items-center py-2 ">
        <div className="flex items-center space-x-6 text-gray-800 text-sm font-medium">
          {pages.map((page) => (
            <span
              key={page}
              onClick={() => setActivePage(page)}
              className={`cursor-pointer ${activePage === page
                ? "text-blue-600 border-b-2 border-blue-600 pb-1"
                : "hover:text-blue-600"
                }`}
            >
              {page}
            </span>
          ))}
        </div>
      </header>
      {/* {activePage === "Default OwnerDashboard" && <OwnerOwnerDashboard />} */}
      {activePage === "HR Dashboard" && <HrDashboard />}
      {activePage === "ACC Dashboard" && <AccDashboard />}
      {activePage === "Inventory Dashboard" && <InventoryDashboard />}
      {activePage === "Company Information" && <CompanyInfo />}
    </div>
  );
}

export default OwnerDashboard;
